import { render } from "./region-info.vue?vue&type=template&id=d8af9bbc"
import script from "./region-info.vue?vue&type=script&lang=js"
export * from "./region-info.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__